import React from 'react';
import ReactionListItem from './reactionListItem';


export default function ReactionsList({
  reactions,
  blockName,
  selectedReaction,
  onReactionClicked,
  percentages = {},
}){
  const shouldShowVoteResults = !!selectedReaction && percentages;
  const isAnySelected = !!selectedReaction;
  const reactionsElements = reactions.map((reaction, key) => {
    const { id, } = reaction;
    const percentage = percentages[id] || 0;
    const isSelected = selectedReaction && selectedReaction === id;
    const reactionListItemParams = {
      reaction, percentage, shouldShowVoteResults,
      blockName, key, isSelected, onReactionClicked, isAnySelected,
    };
    return <ReactionListItem { ...reactionListItemParams } />;
  });
  return (
    <ul className={ `${ blockName }__list` }>
      { reactionsElements }
    </ul>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/components/reactionList.js